<template>
    <div>
      <h2>반관리</h2>
      <p>
        반의 위계는 반형태 > 반으로 나뉩니다.<br/>
        반형태는 반들이 묶여 있는 그룹입니다. 반에는 담임 / 교실 / 수강료 등의 정보가 저장됩니다.<br/>
        반 안에 여러 개의 과목을 설정할 수 있고, 과목마다 강사를 다르게 입력할 수 있습니다.<br/>
        예를들어, 과학반에는 물리/지학/화학/생물의 과목을 추가할 수 있습니다. 수학반에는 내신/심화 과목을 묶어서 하나의 반으로 만들 수 있습니다. 물론 필요하다면 각 과목을 반으로 만드는 것도 가능합니다.<br/>
      </p>
      
      <section>
        <div class="p-relative section_0" id="class_type">
            <div class="ft-b">1)  반형태</div>
        
            <div class="p-relative section_2">
                <div><img src="@/assets/aca/manual/staff/staff_class_type.jpg" /></div>
            </div>
            <p></p>
            <div class="p-relative section_1">
                -   “추가”버튼을 클릭하면
            </div>
            <div class="p-relative section_1">
                -   “반형태 다이알로그”에서 반형태를 생성할 수 있습니다.
            </div>
            <div class="p-relative section_2">
                <div><img src="@/assets/aca/manual/staff/staff_class_type_modal.jpg" /></div>
            </div>

            <div class="p-relative section_2">
                반형태의 이름을 입력 후 생성합니다.
            </div>
        </div>

        <p></p>
        <div class="p-relative section_0" id="create_class">
            <div class="ft-b">2)  반 생성</div>
            
            <div class="p-relative section_1">
                -   반형태 리스트에서 반형태를 선택하면 반을 생성할 수 있습니다.
            </div>
            <div class="p-relative section_2">
                <div><img src="@/assets/aca/manual/staff/staff_class_add_button.jpg" /></div>
            </div>

            
            <div class="p-relative section_1">
                -   “반 다이알로그”가 나타나면 다음과 같이 정보를 입력하여 생성합니다.
            </div>
            <div class="p-relative section_2">
                <div><img src="@/assets/aca/manual/staff/staff_class_add_modal.jpg" /></div>
            </div>


            <div class="p-relative section_1">
                -   반을 생성할 때 1) 반이름 2) 반시작일은 필수입력사항입니다.
                        </div>
            <div class="p-relative section_2">
                담임과 수강료는 추후에 추가 또는 변경할 수 있습니다.
                        </div>
            <div class="p-relative section_1">
                -   수강료 자동발생에 “예”를 선택해 놓으면 다음 달의 수강료를 자동으로 발생합니다.
            </div>
        </div>
        
        <p></p>
        <div class="p-relative section_0" id="add_subject">
            <div class="ft-b">3)    반에 과목 추가</div>
            
            <div class="p-relative section_1">
                -   하나의 반에는 여러 개의 과목을 추가할 수 있습니다. 물론 하나의 과목만 추가해도 됩니다. 다만, 최소 1개의 과목은 추가해야 합니다.
            </div>
            <div class="p-relative section_1">
                -   반에 과목을 하나도 추가하지 않는 경우, 시스템이 동작하는데 오류는 없으나, 오늘의 수업정보가 생성되지 않으므로, 홈화면에서 오늘 수업이 무엇인지 나타나지 않습니다.
            </div>

            <div class="p-relative section_2">
                <div><img src="@/assets/aca/manual/staff/staff_class_add_subject.jpg" /></div>
            </div>

            
            <div class="p-relative section_1">
                -   과목에는 아래와 같이 선생님 / 교실 / 교재 / 시간표를 입력합니다.
            </div>
            <div class="p-relative section_2">
                <div><img src="@/assets/aca/manual/staff/staff_class_subject_modal.jpg" /></div>
            </div>
        </div>

        <p></p>
        <div class="p-relative section_0" id="add_textbook">
            <div class="ft-b">4)    교재 등록</div>
            
            <div class="p-relative section_1">
                -   과목에 교재를 등록하기 위해서는 미리 교재가 등록되어 있어야 한다.
            </div>
            <div class="p-relative section_2">
                <div><img src="@/assets/aca/manual/staff/staff_class_add_textbook.jpg" /></div>
            </div>

            
            <div class="p-relative section_1">
                -   “교재등록”버튼을 클릭하면
            </div>
            <div class="p-relative section_1">
                -   “교재 리스트”가 나타나고 다시 “교재추가”버튼을 클릭하여 교재를 등록한다.
            </div>
            <div class="p-relative section_2">
                <div><img src="@/assets/aca/manual/staff/staff_class_textbook_modal.jpg" /></div>
            </div>
        </div>

        
      </section>

      <q-drawer show-if-above side="right" class="bg-white">
          <q-list>
            <q-item-label header style="padding:40px 42px 20px;">바로가기</q-item-label>
            <li class="q-px-lg pointer" 
                      v-for="m in menuItems" 
                      :key="m.label"
                      @click="goTo(m.link)" >
                {{m.label}}
            </li>
            
          </q-list>
      </q-drawer>
    </div>
</template>

<script>
import goto from "./goto.js";
export default {
    components : {
    },
    data : function() {
        return {
            menuItems: [
                { label: '반형태', link: '#class_type' },
                { label: '반 생성', link: '#create_class' },
                { label: '반에 과목 추가', link: '#add_subject' },
                { label: '교재 등록', link: '#add_textbook' },
            ]
        }
    },
    computed :{
    },
    methods : {
        goTo(link) {
            goto.goto_link(link);
        }
    },
    beforeMount() {
        goto.clear();
    }
}
</script>


